module.exports = __webpack_public_path__ + "img/ab.35714e54.svg";